import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from '@michelin/central-provider';
import {
  Container, LoadingBounce, Panel,
} from '@michelin/acid-components';
import useUtils from 'hooks/useUtils';
import { PlainMessage } from 'components/PlainMessage';
import useCommercialERSInformationQuery from 'hooks/useCommercialERSInformation';
import useCommercialLocation from 'hooks/useCommercialLocation';
import { TABBED_CONTENT_HEIGHT } from 'Utils';
import { useLocationST } from 'hooks/useLocation';
import { ChangeLogEntities } from 'Types';
import LastModified from 'components/ChangeLog/LastModified';
import { PageTitle } from 'Utils/CanvasPageTitle';
import ERSPanel from './ERSPanel';

interface ERSDetailsProps {
  action: 'edit' | 'view',
}

export function CommercialERSDetail(props: ERSDetailsProps) {
  const { t } = useTranslation();
  const { stNumber } = useParams<{ stNumber: string }>();
  const locationQuery = useLocationST(stNumber);
  const history = useHistory();
  const commercialQuery = useCommercialLocation(stNumber);
  const commercialERSInformation = useCommercialERSInformationQuery(stNumber);
  const { subTitle } = useUtils();

  if (commercialQuery.isLoading || commercialERSInformation.isLoading) return <LoadingBounce style={{ height: '70vh' }} />;
  if (!commercialERSInformation.data) return <PlainMessage title={t('Error loading commercial ers information')} messages={t('Please try again later')} />;
  if (!!locationQuery.data?.kad_location && !locationQuery.data?.commercial_truck_location) return history.push('/');

  return (
    <>
      <PageTitle
        title={t('ERS Information')}
        subtitle={subTitle}
        rightItems={(<LastModified entity={ChangeLogEntities.ers} />)}
      />
      <Container>
        <Panel style={{ minHeight: TABBED_CONTENT_HEIGHT }}>
          <ERSPanel
            ersInformation={commercialERSInformation.data}
            action={props.action}
          />
        </Panel>
      </Container>
    </>
  );
}
